<template>
  <div class="setup-password-page">
    <SetupPassword :email="getEmail" :token="getToken" />
  </div>
</template>

<script>
import { SetupPassword } from '@/features/register';

export default {
  components: { SetupPassword },
  computed: {
    getEmail() {
      return this.$route.params.email;
    },
    getToken() {
      return this.$route.params.token;
    },
  },
};
</script>
